<template>
	<div class="slider-image-item">
		<div class="bordered-item">
			<div class="tile-image bordered-item-wrapper">
				<Carousel v-model:page="activeItemIndex" :value="itemList" :num-visible="1" :num-scroll="1" :autoplay-interval="4000" circular :showNavigators="false" :show-indicators="false">
					<template #item="{ data }">
						<img v-if="data.ImageUrl" :src="data.ImageUrl" :alt="data.ImageAltText" />
					</template>
				</Carousel>
			</div>
		</div>
		<div class="slider-dots">
			<ul class="d-flex flex-v-centre flex-h-centre">
				<li v-for="(item, index) in itemList" :key="index" :class="['slider-dot', { active: index === activeItemIndex }]" @click="activeItemIndex = index"></li>
			</ul>
		</div>
	</div>
</template>
<script lang="ts" setup>
	import Carousel from 'primevue/carousel';
	import { onMounted, ref } from 'vue';

	interface ImageSliderModel {
		ImageUrl?: string;
		ImageAltText?: string;
	}

	const props = defineProps({
		items: {
			type: String,
			required: true,
		},
	});

	const activeItemIndex = ref<number>(0);
	const itemList = ref<ImageSliderModel[]>([]);

	onMounted(() => {
		itemList.value = JSON.parse(props.items);
	});
</script>
